import { createApi } from "@reduxjs/toolkit/query/react";
import { edenBaseQuery } from "@/src/common/lib/eden-base-query";

export const baseApi = createApi({
	reducerPath: "api",
	baseQuery: edenBaseQuery(),
	tagTypes: [
		"AIChatUsage",
		"Analytics",
		"ApiKeys",
		"Availability",
		"Bookmarks",
		"BrowseGroups",
		"Calendar",
		"Comments",
		"Community",
		"CommunityLinks",
		"CommunitySettings",
		"Drafts",
		"EventDates",
		"EventDetail",
		"Events",
		"Feed",
		"GroupJoinRequests",
		"GroupJoinRequestsCount",
		"Groups",
		"Invitations",
		"MeetingDates",
		"MeetingDetail",
		"Meetings",
		"MemberDetail",
		"Members",
		"MyGroupRequests",
		"MyGroups",
		"Notifications",
		"Post",
		"PublicCommunity",
		"Reports",
		"Scheduled",
		"Skills",
		"SponsoredContent",
		"StaffCommunities",
		"StaffCommunityMobileApp",
		"UnreadCount",
		"WebhookDeliveries",
		"Webhooks",
	],
	endpoints: () => ({}),
});
